<template>
  <div>
    <loader :loader="loader"></loader>
    <div>
      <RNPLNavbar>
        <div class="nav__left">
          <h2 class="title">Good Morning, Michael</h2>
          <p class="sub-title">Welcome to your RNPL Dashboard</p>
        </div>
      </RNPLNavbar>
      <div v-if="!showAnalytics">
        <Card
          :styleObj="{ borderRadius: '12px', padding: '26px', border: 'none' }"
        >
          <div class="header">
            <div class="header-left">
              <h2 class="text">Overview</h2>
              <p class="sub-text">
                Here’s a quick overview of what’s happening
              </p>
            </div>
            <div class="filter__wrap" @click.stop>
              <div
                class="filter-selected"
                @click="showFilterMenu = !showFilterMenu"
              >
                {{ filter.text }}
                <svgicon
                  icon="drop-down"
                  :class="`filter-icon ${showFilterMenu && 'active'}`"
                ></svgicon>
              </div>
              <ul
                v-if="showFilterMenu"
                :class="`header-filter ${showFilterMenu && 'active'}`"
              >
                <li
                  v-for="(el, index) in filterOption"
                  :key="index"
                  @click="handleFilter(el)"
                >
                  {{ el.text }}
                </li>
              </ul>
            </div>
          </div>
          <div class="card__content">
            <Card
              :styleObj="{ padding: '24px', width: '30%', minWidth: '218px' }"
            >
              <div class="inner-wrap">
                <FigureIcon :class="'figure-icon'" />
                <div class="text-wrap">
                  <p class="sub-text">PENDING REQUESTS</p>
                  <h2
                    class="amount"
                    v-html="formatAmount(dashboardData.totalPendingLoans)"
                  ></h2>
                </div>
                <p class="text-filter">{{ filter.value | capitalize }}</p>
              </div>
            </Card>
            <Card :styleObj="{ padding: '17px', flex: '1' }" class="loan">
              <div class="loan__left">
                <div class="loan__left-top">
                  <div class="content">
                    <p class="total-disbursement">TOTAL DISBURSEMENT</p>
                    <h2 class="figure">
                      {{ dashboardData.totalDisbursedLoans }}
                    </h2>
                    <p class="text">{{ filter.value | capitalize }}</p>
                  </div>
                </div>
                <div class="loan__left-bottom">
                  <div class="content bottom">
                    <p class="total-disbursement">ACTIVE LOANS</p>
                    <h2 class="figure">
                      {{ dashboardData.activeLoanPercent }}%
                    </h2>
                    <p class="text">{{ filter.value | capitalize }}</p>
                  </div>
                </div>
              </div>
              <div class="loan__left right">
                <div class="loan__left-top top-right">
                  <div class="content">
                    <p class="total-disbursement">NON PERFORMING LOANS</p>
                    <h2 class="figure">
                      {{ dashboardData.NonPerformingLoansPercent }}%
                    </h2>
                    <p class="text">{{ filter.value | capitalize }}</p>
                  </div>
                </div>
                <div class="loan__left-bottom bottom-right">
                  <div class="content bottom">
                    <p class="total-disbursement">PORTFOLIO AT RISK</p>
                    <h2 class="figure">
                      {{ dashboardData.portfolioAtRiskPercent }}%
                    </h2>
                    <p class="text">{{ filter.value | capitalize }}</p>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </Card>
        <div class="table-header">
          <div class="left">
            <h2 class="text">Request</h2>
            <p class="sub-text">
              Here’a a breakdown of the recent requests on RNPL
            </p>
          </div>
          <router-link to="/loans" class="see-all-request"
            >See all requests <svgicon icon="drop-down" class="dir"
          /></router-link>
        </div>
        <Table>
          <template #head>
            <thead>
              <tr>
                <th class="dashboard__payment-history-table-heading"></th>
                <th class="dashboard__payment-history-table-heading">
                  Full Name
                </th>
                <th class="dashboard__payment-history-table-heading">
                  Date
                </th>
                <th class="dashboard__payment-history-table-heading">
                  Amount
                </th>
                <th class="dashboard__payment-history-table-heading">
                  Status
                </th>
                <th class="dashboard__payment-history-table-heading">
                  Action
                </th>
              </tr>
            </thead>
          </template>
          <template #body>
            <tbody>
              <tr v-for="request in listOfLoans" :key="request.id">
                <td
                  class="dashboard__payment-history-table-data dashboard__listing-table"
                >
                  <!-- <div
                  v-if="request?.images?.length > 0"
                  class="dashboard__listing-img"
                  :style="{
                    backgroundImage: 'url(' + request?.images + ')'
                  }"
                ></div> -->
                </td>
                <td
                  class="dashboard__payment-history-table-data dashboard__listing-table"
                >
                  {{ request.user | capitalize }}
                </td>
                <td
                  class="dashboard__payment-history-table-data dashboard__listing-table"
                  v-html="formatDate(request.createdAt)"
                ></td>
                <td
                  class="dashboard__payment-history-table-data dashboard__listing-table"
                >
                  <p
                    class="mb-0"
                    v-html="formatAmount(request.requestedAmount)"
                  ></p>
                </td>
                <td
                  class="dashboard__payment-history-table-data dashboard__listing-table"
                >
                  <StatusBadge :status="request.status" />
                </td>
                <td
                  class="dashboard__payment-history-table-data dashboard__listing-table"
                >
                  <b-dropdown
                    id="dropdown-left"
                    size="lg"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                  >
                    <template v-slot:button-content>
                      <svgicon
                        icon="table-menu"
                        class="dashboard__listing-table-menu"
                      ></svgicon>
                    </template>
                    <b-dropdown-item :to="`/loan-details/${request.id}`"
                      >View</b-dropdown-item
                    >
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </template>
        </Table>
      </div>

      <div v-else class="analytics">
        <h1>Analytics Charts</h1>
      </div>
    </div>
  </div>
</template>

<script>
import RNPLNavbar from "./RNPLNavbar.vue";
import Card from "../resuables/card.vue";
import FigureIcon from "../icons/dashboard/figureIcon.vue";
import Table from "../resuables/table.vue";
import loader from "../resuables/loader";
import { getAllLoans, getDashboardDataApi } from "../../../services/loans";
import { formatReadbleDate, formatCurrencyAmount } from "../../utils/index";
import StatusBadge from "../general/statusBadge.vue";
import { mapState } from "vuex";

export default {
  components: { RNPLNavbar, Card, FigureIcon, Table, loader, StatusBadge },
  data() {
    return {
      filter: { text: "All", value: "all" },
      showFilterMenu: false,
      loader: false,
      listOfLoans: [],
      dashboardData: {}
    };
  },
  methods: {
    handleFilter(value) {
      this.filter = value;
      this.showFilterMenu = false;
      this.getDashboardData(this.filter.value);
    },
    clickaway() {
      if (this.showFilterMenu) {
        this.showFilterMenu = false;
      }
    },
    async handleAllLoans() {
      this.loader = true;
      const payload = {
        page: this.pages,
        limit: this.pageSize
      };

      try {
        const res = await getAllLoans(payload);
        this.listOfLoans = res.data.loans;
        this.loader = false;
      } catch (error) {
        this.loader = false;
        return error;
      }
    },
    async getDashboardData(value) {
      this.loader = true;
      try {
        const res = await getDashboardDataApi(value);
        this.dashboardData = res.data;
        this.loader = false;
      } catch (error) {
        this.loader = false;
        return error;
      }
    },
    formatDate(date) {
      return formatReadbleDate(date);
    },
    formatAmount(data) {
      return formatCurrencyAmount(data);
    }
  },
  async mounted() {
    window.addEventListener("click", this.clickaway);
    await Promise.all([
      this.handleAllLoans(),
      this.getDashboardData(this.filter.value)
    ]);
  },
  destroyed() {
    window.removeEventListener("click", this.clickaway);
  },
  computed: {
    ...mapState({
      showAnalytics: state => state.rnpl.showAnalytics
    }),
    filterOption() {
      return [
        { value: "all", text: "All" },
        { value: "monthly", text: "Month" },
        { value: "quarterly", text: "Quarter" },
        { value: "biannually", text: "Biannual" },
        { value: "yearly", text: "Year" }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: auto;
  margin-bottom: 16px;

  .filter__wrap {
    position: relative;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #0f0c3d;
    cursor: pointer;
    user-select: none;
    margin-left: auto;

    .filter-selected {
      background: #fafafe;
      border: 0.4px solid #99a4e1;
      border-radius: 22px;
      padding: 14px;
      width: 128px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 2px -1px 8px rgba(0, 0, 0, 0.16);

      .filter-icon {
        fill: none;
        width: 10px;
        stroke: rgba(0, 0, 0, 0.4);
        stroke-width: 20px;
        margin-left: 4px;
        transition: all ease 0.25s;

        &.active {
          transform: rotate(180deg);
        }
      }
    }

    .header-filter {
      position: absolute;
      border: 0.4px solid #99a4e1;
      width: 100%;
      border-radius: 6px;
      top: 105%;
      z-index: 2;
      background: white;
      box-shadow: 4px 6px 16px rgba(0, 0, 0, 0.16);

      li {
        padding: 12px 6px;
        border-bottom: 0.4px solid #99a4e1;

        &:last-child {
          border: none;
        }
      }
    }
  }
}
.card {
  &__content {
    display: flex;
    gap: 16px;

    .inner-wrap {
      .figure-icon {
        margin-top: 20px;
      }
      .text-wrap {
        margin-top: 21px;
        padding-bottom: 22px;
        border-bottom: 1px solid #e0def7;

        .sub-text {
          font-weight: 600;
          font-size: 12px;
          line-height: 15px;
          color: #63687e;
          margin-bottom: 12px;
        }
        .amount {
          font-weight: 600;
          font-size: 25px;
          line-height: 38px;
          color: #101828;
        }
      }
      .text-filter {
        margin-top: 12px;
        margin-bottom: 0;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 150%;
        color: #000000;
      }
    }
    .loan {
      display: flex;
      flex-direction: row;
      &__left {
        border-right: 1px solid #e0def7;
        flex: 1;

        &-top {
          border-bottom: 1px solid #e0def7;
          margin-right: 16px;

          &.top-right {
            margin-right: 0;
            margin-left: 16px;
          }
        }
        &-bottom {
          margin-right: 16px;

          &.bottom-right {
            margin-right: 0;
            margin-left: 16px;
          }
        }

        .content {
          padding-bottom: 16px;
          padding-left: 8px;
          padding-right: 8px;
          padding-top: 4px;

          .total-disbursement {
            font-weight: 600;
            font-size: 12px;
            line-height: 15px;
            color: #63687e;
            margin-bottom: 6px;
          }
          .figure {
            font-weight: 700;
            font-size: 32px;
            line-height: 125%;
            letter-spacing: -0.01em;
            color: #000929;
            margin-bottom: 9px;
          }
          .text {
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: #63687e;
            margin-bottom: 0;
          }
          &.bottom {
            padding-top: 16px;
            padding-bottom: 0;
          }
        }
        &.right {
          border-right: 0;
        }
      }
      &__right {
        flex: 1;
        padding: 16px;
      }
    }
  }
}
.table-header {
  margin-top: 52px;
  margin-bottom: 21px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .see-all-request {
    font-weight: 700;
    font-size: 14px;
    line-height: 140%;
    color: #2e48da;
    // text-decoration: none;
    .dir {
      width: 10px;
      transform: rotate(-90deg);
      fill: none;
      stroke: #2e48da;
    }
  }
}
// General
.text {
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  color: #242428;
}
.sub-text {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #63687e;
}

@media screen and (max-width: 1000px) {
  .card {
    &__content {
      flex-direction: column;

      .card {
        width: 100% !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/RNPLDashboard.vue